/* Each page owns its blocks; shared presentation only. No external libraries. */
if (!customElements.get('monblari-faq-page')) {
  customElements.define('monblari-faq-page', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.onClick = event => {
        const link = event.target.closest('[data-faq-topic]');
        if (!link || !this.contains(link)) return;
        event.preventDefault();
        this.show(link.dataset.faqTopic);
      };
      this.onBlock = event => {
        if (!this.contains(event.target)) return;
        const group = event.target.closest('[data-faq-group]');
        if (group) this.show(group.dataset.faqGroup);
        const item = event.target.closest('[data-faq-item]');
        if (item) item.open = true;
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlock);
      const groups = Array.from(this.querySelectorAll('[data-faq-group]'));
      const current = groups.find(group => '#' + group.id === location.hash) || groups[0];
      if (current) this.show(current.dataset.faqGroup);
    }
    show(id) {
      this.querySelectorAll('[data-faq-group]').forEach(group => {
        group.hidden = group.dataset.faqGroup !== id;
      });
      this.querySelectorAll('[data-faq-topic]').forEach(link => {
        if (link.dataset.faqTopic === id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlock);
      this.bound = false;
    }
  });
}
